import { digitsEnToFa } from '@persian-tools/persian-tools';
import moment from 'jalali-moment';

/**
 * Every visit and deadline is the clinic's time in Iran, whatever the device's time zone is set to. Iran has
 * kept a fixed +03:30 (no daylight saving) since 2022, so a fixed offset is exact.
 */
const TEHRAN_OFFSET_MINUTES = 210;
const tehran = (iso: string) => moment(iso).utcOffset(TEHRAN_OFFSET_MINUTES);

/** «یکشنبه ۲۶ مهر، ساعت ۱۰:۲۰» — Persian digits in the string itself, not left to the font. */
export const formatVisit = (iso?: string) => (iso ? digitsEnToFa(tehran(iso).locale('fa').format('dddd jD jMMMM، [ساعت] HH:mm')) : '');

/** «۱۰:۲۰» */
export const formatClock = (iso?: string) => (iso ? digitsEnToFa(tehran(iso).format('HH:mm')) : '');

/** «۲۵ آبان» or, with the year, «۲۵ آبان ۱۴۰۵» */
export const formatDate = (iso?: string, withYear = false) =>
  iso ? digitsEnToFa(tehran(iso).locale('fa').format(withYear ? 'jD jMMMM jYYYY' : 'jD jMMMM')) : '';

/** A held slot's time: the formatted time, or the clinic's own wording when it gave no time. */
export const formatOfferVisit = (offer?: { visitAt?: string; visitLabel?: string } | null) =>
  offer?.visitAt ? formatVisit(offer.visitAt) : offer?.visitLabel ? digitsEnToFa(offer.visitLabel) : '';
